import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueMarkdown from 'vue-markdown';
import CheckList from '@/components/CheckList.vue';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
let CharacterSheetExpansionFeatures = class CharacterSheetExpansionFeatures extends Vue {
};
__decorate([
    Prop(Array)
], CharacterSheetExpansionFeatures.prototype, "features", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheetExpansionFeatures.prototype, "isShowingLevel", void 0);
CharacterSheetExpansionFeatures = __decorate([
    Component({
        components: {
            CheckList,
            VueMarkdown,
            ConfirmDelete
        }
    })
], CharacterSheetExpansionFeatures);
export default CharacterSheetExpansionFeatures;
